import React, { useState, useEffect, lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes, Link, NavLink, Navigate, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import BlogPost from './components/BlogPost';
import BlogPosts from './components/BlogPosts';
import Sidebar from './components/Sidebar';
import Seo from './components/Seo';
import './style.css';
const LessonSlider = lazy(() => import('./components/LessonSlider'));
const Advisory = lazy(() => import('./components/Advisory'));
const Agents = lazy(() => import('./components/Agents'));
const Lessons = lazy(() => import('./components/Lessons'));
const MusicMap = lazy(() => import('./components/MusicMap'));
const Answers = lazy(() => import('./components/PrivatePages'));
const Publisher = lazy(() => import('./components/PrivatePages').then(module => ({default:module.Publisher})));

function Site() {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setMenuOpen(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);
  return <>
    <Seo />
    <Helmet defaultTitle="Blog — Simone Di Somma">
      <meta name="viewport" content="width=device-width, initial-scale=1" />
    </Helmet>
    <a className="skip-link" href="#main">Skip to content</a>
    <header className="site-header">
      <div className="site-shell header-inner">
        <Link to="/" className="brand"><img src="/static/three-stars.svg" className="brand-stars" alt="" width="40" height="40" /><span>Simone <span className="brand-surname">Di Somma</span></span></Link>
        <button className="menu-toggle" aria-expanded={menuOpen} aria-controls="site-nav" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? 'Close' : 'Menu'}</button>
        <nav id="site-nav" aria-label="Main navigation" className={menuOpen ? 'site-nav is-open' : 'site-nav'}>
          <NavLink to="/" end>Blog</NavLink>
          <NavLink to="/post/about-me">About me</NavLink>
          <NavLink to="/advisory">Talk to me</NavLink>
        </nav>
      </div>
    </header>
    <main id="main" className="site-shell">
      <Suspense fallback={<p role="status">Loading…</p>}><Routes>
        <Route path="/" element={<div className="home-layout"><BlogPosts /><Sidebar /></div>} />
        <Route path="/blog-posts" element={<Navigate to="/" replace />} />
        <Route path="/post/2026-11-04-kasabian-act-iii" element={<Navigate to="/post/2026-11-01-kasabian-act-iii" replace />} />
        <Route path="/post/:slug" element={<div className="article-layout"><BlogPost /><Sidebar /></div>} />
        <Route path="/category/:category" element={<div className="home-layout"><BlogPosts /><Sidebar /></div>} />
        <Route path="/advisory" element={<Advisory />} />
        <Route path="/agents" element={<Agents />} />
        <Route path="/answers" element={<Answers />} />
        <Route path="/advisory-admin" element={<Publisher />} />
        <Route path="/lessons" element={<Lessons />} />
        <Route path="/music-map" element={<MusicMap />} />
        <Route path="/lesson/:lessonId" element={<LessonSlider />} />
        <Route path="*" element={<div className="main-content"><h1>Page not found</h1><Link to="/">Back to the blog</Link></div>} />
      </Routes></Suspense>
    </main>
    <footer className="site-footer site-shell"><span>© {new Date().getFullYear()} Simone Di Somma</span><Link to="/music-map">Places & records</Link><Link to="/agents">Agent-friendly · MCP</Link></footer>
  </>;
}
export default function App() {
  return <HelmetProvider><BrowserRouter><Site /></BrowserRouter></HelmetProvider>;
}
